import { getCurrentInstance, shallowRef } from 'vue'
import type { ShallowRef } from 'vue'
import { router } from '@/router'
import type VueRouter from 'vue-router'
import type { Route } from 'vue-router'

export function useRouter(): VueRouter {
  const vm = getCurrentInstance()

  if (vm) {
    return router
  }

  console.warn('请在 setup 中调用。')

  return router
}

let currentRoute = shallowRef()

export function useRoute(): ShallowRef<Route> {
  if (!currentRoute.value) {
    const vm = getCurrentInstance()

    if (!vm) {
      console.warn('请在 setup 中调用。')
      return currentRoute
    }

    currentRoute.value = vm.proxy.$route

    // 每次路由切换时，更新 route 参数
    const router = useRouter()
    if (router) {
      router.afterEach((to) => (currentRoute.value = to))
    }
  }

  return currentRoute
}
